import "./base";

import "www-templates/scss/estilos-movil.scss";
import init from "../utils/init";
import {MenusLoader} from "../loaders/menus";

init.addLoader(MenusLoader);
